import { LuIcon, Menu, type MenuGroupProps } from "@overmap-ai/blocks"
import { AssetStatusType } from "@overmap-ai/common"
import { memo } from "react"

import { assetStatusTypeMapping } from "../../mappings/assets"

export interface AssetStatusTypeMenuGroupProps extends MenuGroupProps {
	assetStatusTypes: AssetStatusType[]
	onSelectAssetStatusType: (assetStatusType: AssetStatusType) => void
}

export const AssetStatusTypeMenuGroup = memo<AssetStatusTypeMenuGroupProps>((props) => {
	const { ref, assetStatusTypes, onSelectAssetStatusType, ...rest } = props

	return (
		<Menu.Group ref={ref} {...rest}>
			{assetStatusTypes.map((assetStatusType) => {
				const { icon, label, color } = assetStatusTypeMapping[assetStatusType]
				return (
					<Menu.Item key={assetStatusType} onSelect={() => onSelectAssetStatusType(assetStatusType)}>
						<LuIcon icon={icon} color={color} />
						<span className="truncate">{label}</span>
					</Menu.Item>
				)
			})}
		</Menu.Group>
	)
})
AssetStatusTypeMenuGroup.displayName = "AssetStatusTypeMenuGroup"
